import { createRouter, createWebHistory } from 'vue-router';
import { nextTick } from 'vue';
import routes from '../routes.js';
import { kartenansichtIdOf } from '../composables/useLayers.js';
import { KARTENANSICHT_KATEGORIEN } from '../constants.js';

/**
 * @param {string|Array<string>} value
 * @returns {string}
 */
export function first(value) {
  return Array.isArray(value) ? value[0] : value;
}

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  let { params, query } = to;
  if (to.name === 'Map' || to.name === 'MapEmbed' || to.name === 'Data') {
    const { currentKartenansichtId, error, updateVisibleLayers } = await import(
      '../composables/useLayers.js'
    );
    const id = params.kartenansichtId;

    if (id === undefined || id === '') {
      params = {
        ...params,
        kartenansichtId: await kartenansichtIdOf(
          KARTENANSICHT_KATEGORIEN.oeffentlich
        ),
      };
    }

    if (id !== undefined) {
      const previousKartenansichtId = currentKartenansichtId.value;
      currentKartenansichtId.value = Array.isArray(id) ? id[0] : id;
      if (previousKartenansichtId !== currentKartenansichtId.value) {
        // Wait until watchers in useLayers have cleared the old kartenansicht
        await nextTick();
      }
    }
    // updateVisibleLayers resolves when the new kartenansicht is loaded
    await updateVisibleLayers(first(params.visibleLayers));
    // now we have all data updated and can do all the math
    if (error.value) {
      // The kartenansicht was not found, redirect
      // return { name: 'Dashboard' };
    }
  }
  if (to.name === 'Map' || to.name === 'MapEmbed') {
    const { visibleLayersRouteParam } = await import(
      '../composables/useLayers.js'
    );
    const { xyzQuery } = await import('../composables/useLayers.js');
    if (
      visibleLayersRouteParam.value &&
      (params.visibleLayers !== visibleLayersRouteParam.value ||
        !params.visibleLayers)
    ) {
      params = { ...params, visibleLayers: visibleLayersRouteParam.value };
    }
    if (query.x === undefined) {
      query = { ...query, ...xyzQuery.value };
    }
    if (params !== to.params || query !== to.query) {
      return {
        ...to,
        params,
        query,
      };
    }
  }
  return undefined;
});

// router.afterEach(async (to) => {
//   if (
//     to.name !== 'Login' &&
//     (!UserData || !UserData.value || !UserData.value.id)
//   ) {
//     router.push({ name: 'Login' });
//   }
//   return undefined;
// });

export default router;
